import { useState, useEffect, useMemo } from "react";
import axios from "axios";
import styled from "styled-components";
import { toast } from "react-toastify";

import { ImArrowLeft, ImArrowRight } from "react-icons/im";
import Swal from "sweetalert2";



const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

`;
const ScrollableContainer = styled.div`
  width: 100%;
  max-height: 80vh; 
  overflow-y: auto;
`;

const TableWrapper = styled.div`

  overflow: auto;
  border-radius: 7px;
  background: #fff;
  

  max-width: 98%;   /* limite de largura */
  margin: auto;   /* centraliza */
  padding: 12px;/* leve respiro interno */
`;

export const Table = styled.table`
 
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;

  /* (opcionais do seu layout externo) */
  box-shadow: 0 0 2px #ccc;
  border-radius: 7px;
  margin-bottom: 10px;

  /* células padrão */
  th, td {
    padding: 12px 14px;
    font-size: 14px;
    color: #333;
  }

  /* cabeçalho fixo */
  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fafafa;
    color: #555;
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  /* listras + hover */
  tbody tr { transition: background 0.15s ease; }
  tbody tr:nth-child(even) { background: #fcfcfc; }
  tbody tr:hover { background: #E5F7EE; }

  /* divisórias e alinhamento */
  tbody td {
    border-bottom: 1px solid #f0f0f0;

  }
  tbody tr:last-child td { border-bottom: 0; }

  /* cantos arredondados */
  thead th:first-child { border-top-left-radius: 5px; }
  thead th:last-child  { border-top-right-radius: 5px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 5px; }
  tbody tr:last-child td:last-child  { border-bottom-right-radius: 5px; }

  /* descrição com quebra — sem mudar seu JSX (4ª coluna) */
  tbody td:nth-child(4) {
    max-width: 520px;
    white-space: pre-wrap;
    word-break: break-word;
  }

  @media (max-width: 780px) {
    min-width: 600px; /* força scroll horizontal no mobile */
    th, td { padding: 10px 12px; font-size: 13px; }
  }
`;

const ActionButton = styled.button`
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: transform .12s ease;
  &:hover { transform: scale(1.03); }
`;

const TdButton = styled.td`
  font-size: 16px;
  font-weight: bold;
  word-break: break-word;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  color: #575757;
  text-align: center;
  &:hover {
    transform: scale(1.3);
      
  }
  @media (max-width: 768px) {
    ${(props) => props.hideOnMobile && "display: none;"}
    display: flex;
    justify-content: center;
    padding: 5px 0;
    font-size: 14px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin: 5px 0px;
    padding: 10px 0px;
    &::before {
      content: attr(data-label); /* Exibe o cabeçalho como rótulo no layout de cards */
      font-weight: bold;
      margin-right: 10px;
    }
  }
`;

const Thead = styled.thead`
  @media (max-width: 768px) {
    display: none;
  }
`;

const Tbody = styled.tbody`
  padding-bottom: 25px; 

  @media (max-width: 768px) {
    display: block; /* Torna cada linha um card */
  }
`;

const Tr = styled.tr`
  text-align: center;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    margin-bottom: 10px;
  }
`;

const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;

  @media (max-width: 768px) {
    ${(props) => props.hideOnMobile && "display: none;"}
    display: none; /* Oculta cabeçalhos no layout de cards */
  }
`;

const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding: 8px 0;
    width: auto;
    &::before {
      content: attr(data-label);
      font-weight: bold;
      color: #333;
      margin-right: 10px;
    }
  }
`;


const Td3 = styled.td`
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin: 10px 0px;
  align-items: center;

  span{
    margin: 0px 5px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    text-align: center;
    gap: 15px;
  }

`;

const Input = styled.input`
  width: 500px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.3);
  }
`;

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;

const Select = styled.select`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;



const Grid = ({ urlApi, modalEditarLancamentos, modalLancamentoMateriais, setAtualizaLancamentos, tipoMaterial, showGrid, listaLancamento }) => {

  //Token da api
  const token = localStorage.getItem('token');




  //----------------------------------------CHAMA o MODAL DE EDITAR USUARIO E ACESSOS--------------------------------------------------///

  const handleEdit = (item) => {
    modalEditarLancamentos(item);

  };

  //---------------------------------------FUNÇÂO DELETAR USUARIO---------------------------------------------------//


  //PopUp de confirmação
  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Deseja o apagar o lançamento?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container',
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };


  // Deleta os usuários
  const handleDelete = async (item) => {
    const userConfirmed = await showPopUp();

    if (!userConfirmed) {
      return;
    }

    try {
      // Tenta realizar a requisição para deletar o usuário
      await axios.delete(`${urlApi}controle-reagentes/deletar-lancamento`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          data: item.DATA_FORMATADA,         // ou item.DATA se for timestamp puro
          cod_material: item.COD_MATERIAL,
          tipo: item.DESC_TIPO === "Entrada" ? "E" : "S",
          quantidade: item.QUANTIDADE
        }
      });

      toast.success("Lançamento deletado com sucesso.");
      setAtualizaLancamentos(true)

    } catch (error) {

      toast.error(error);


    }


  };

  //---------------------------------------FUNÇÂO DE PESQUISA---------------------------------------------------//

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(listaLancamento);
  const [isLoading, setIsLoading] = useState(true);

  //--------------------MONTA OS SELECTS
  const tiposUnicos = [...new Set(listaLancamento.map(item => item.DESC_TIPO))];

  const situacoesUnicas = [...new Set(listaLancamento.map(item => item.DESC_SITUACAO))];
  const [filtroTipo, setFiltroTipo] = useState('');
  const [filtroSituacao, setFiltroSituacao] = useState('');
  const [tipoSelecionado, setTipoSelecionado] = useState('')



  //Input de pesquisa
  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const lowerTerm = term.toLowerCase();

      const filtered = listaLancamento.filter((item) => {
        // Campo de busca (texto livre)
        const data = (item.DATA_FORMATADA || '').toLowerCase();
        const codMaterial = (item.COD_MATERIAL || '').toString().toLowerCase();
        const descricao = (item.DESCRICAO || '').toLowerCase();
        const descTipo = (item.DESC_TIPO || '').toLowerCase();
        const descSituacao = (item.DESC_SITUACAO || '').toLowerCase();

        const passaBusca =
          data.includes(lowerTerm) ||
          codMaterial.includes(lowerTerm) ||
          descricao.includes(lowerTerm) ||
          descTipo.includes(lowerTerm) ||
          descSituacao.includes(lowerTerm);

        // Filtro por tipo material (numérico)
        const passaFiltroTipoMaterial =
          tipoSelecionado === '' ||
          Number(item.TIPO_MATERIAL) === parseInt(tipoSelecionado, 10);

        // Filtros por descrição textual (string exata)
        const passaFiltroTipoDesc = filtroTipo === '' || item.DESC_TIPO === filtroTipo;
        const passaFiltroSituacao = filtroSituacao === '' || item.DESC_SITUACAO === filtroSituacao;

        return (
          passaBusca &&
          passaFiltroTipoMaterial &&
          passaFiltroTipoDesc &&
          passaFiltroSituacao
        );
      });

      setFilteredUsers(filtered);
      setCurrentPage(1);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    } finally {
      setIsLoading(false);
    }
  };




  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, listaLancamento, tipoSelecionado, filtroTipo, filtroSituacao]);

  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//
  //Paginação

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);

  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };

  //---------------------------------------MODAL CADASTRAR USUARIOS---------------------------------------------------//
  // Chama o modal de cadastrar usuários
  const handleLancamentoMateriais = () => {
    modalLancamentoMateriais()
  };





  return (


    <ScrollableContainer>
      <Container>

        {showGrid && (


          <>
            <Td3 >
              <Input
                type="text"
                placeholder="Pesquisar... Ex: código, descrição, tipo ou subtipo"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Select
                value={tipoSelecionado}
                onChange={(e) => setTipoSelecionado(e.target.value)}
              >
                <option value="">Todos os materiais</option>
                {tipoMaterial.map((tipo) => (
                  <option key={tipo.COD_TIPO} value={tipo.COD_TIPO}>
                    {tipo.DESC_TIPO}
                  </option>
                ))}
              </Select>
              <Select value={filtroTipo} onChange={(e) => setFiltroTipo(e.target.value)}>
                <option value="">Todos os tipos</option>
                {tiposUnicos.map((tipo, idx) => (
                  <option key={idx} value={tipo}>{tipo}</option>
                ))}
              </Select>
              <Select value={filtroSituacao} onChange={(e) => setFiltroSituacao(e.target.value)}>
                <option value="">Todas as situações</option>
                {situacoesUnicas.map((sit, idx) => (
                  <option key={idx} value={sit}>{sit}</option>
                ))}
              </Select>

              <Select value={itemsPerPage} onChange={(e) => {
                const value = e.target.value === "all" ? sortedData.length : parseInt(e.target.value);
                setItemsPerPage(value);
                setCurrentPage(1); // Resetar para a primeira página sempre que mudar
              }}>
                <option value={10}>10 por página</option>
                <option value={50}>50 por página</option>
                <option value={100}>100 por página</option>
                <option value="all">Todos</option>
              </Select>

              <Div>
                <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                  <ImArrowLeft size={20} />
                </Button>
                <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
                <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
                  <ImArrowRight size={20} />
                </Button>
              </Div>




            </Td3>

            {currentItems.length === 0 ? (
              <Tr>
                <Td colSpan={4} style={{ textAlign: 'center', padding: '20px', fontSize: '18px' }}>
                  Não existem saldo para esse código ou período.
                </Td>
              </Tr>
            ) : (
              <TableWrapper>
                <Table>
                  <thead>
                    <tr>
                      <th onClick={() => onColumnClick("DATA_FORMATADA")} className={getSortClass("DATA_FORMATADA")}>
                        Data: {getSortIcon("DATA_FORMATADA")}
                      </th>

                      <th onClick={() => onColumnClick("COD_MATERIAL")} className={getSortClass("COD_MATERIAL")}>
                        Código: {getSortIcon("COD_MATERIAL")}
                      </th>

                      <th onClick={() => onColumnClick("DESCRICAO")} className={getSortClass("DESCRICAO")}>
                        Descrição: {getSortIcon("DESCRICAO")}
                      </th>

                      <th onClick={() => onColumnClick("QUANTIDADE")} className={getSortClass("QUANTIDADE")}>
                        Quantidade: {getSortIcon("QUANTIDADE")}
                      </th>

                      <th onClick={() => onColumnClick("DESC_TIPO")} className={getSortClass("DESC_TIPO")}>
                        Tipo: {getSortIcon("DESC_TIPO")}
                      </th>
                      <th onClick={() => onColumnClick("DESC_SITUACAO")} className={getSortClass("DESC_SITUACAO")}>
                        Situação: {getSortIcon("DESC_SITUACAO")}
                      </th>

                      <th></th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentItems.map((item, i) => (
                      <tr key={i}>
                        <td >{item.DATA_FORMATADA}</td>
                        <td >{item.COD_MATERIAL}</td>
                        <td >{item.DESCRICAO}</td>
                        <td >{item.QUANTIDADE_FORMATADA}</td>
                        <td >{item.DESC_TIPO}</td>
                        <td >{item.DESC_SITUACAO}</td>

                        <td >
                          <ActionButton onClick={() => handleEdit(item)}>
                            Editar
                          </ActionButton>
                        </td>

                        <td >
                          <ActionButton onClick={() => handleDelete(item)}>
                            Deletar
                          </ActionButton>
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </Table>
              </TableWrapper>

            )}

          </>
        )}

      </Container>
    </ScrollableContainer>
  );
};


export default Grid;
